import React from 'react';

import misc from '../../misc';
import './auth.css';

const ForgotPasswordConfirm = props => {
  return (
    <div className="container">
      <div className="row justify-content-md-center">
        <div className="col-md-6">
          <div className="text-center m-4">
            <img
              src={misc.images.logoGrey3}
              width="30"
              height="30"
              className="d-inline-block align-top"
              alt="Federation"
            />
            <h2 className="mb-1 d-inline-block align-bottom">
              &nbsp;Reset Password
            </h2>
          </div>

          <div className="alert alert-success" role="alert">
            Please check your email now and click the confirmation link to reset
            your password.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordConfirm;



// WEBPACK FOOTER //
// ./src/modules/auth/components/ForgotPasswordConfirm.js